module.exports = __webpack_public_path__ + "img/3.08e9cf36.jpg";